import React, { useRef } from "react";
import { gsap } from "gsap";

const SplitTextWithLimitlessIcon = () => {
  const textRef = useRef();
  const iconRef = useRef();

  const handleMouseEnter = () => {
    // Split the text: Left and right
    gsap.to(textRef.current.children[0], { x: -20, duration: 0.4, ease: "power1.out" });
    gsap.to(textRef.current.children[1], { x: 23, duration: 0.4, ease: "power1.out" });

    // Reveal and rotate the Limitless icon
    gsap.to(iconRef.current, {
      scale: 1,
      opacity: 1,
      rotation: 720, // Spin the icon
      duration: 0.7,
      ease: "back.out(1.7)",
    });
  };

  const handleMouseLeave = () => {
    // Reset text position
    gsap.to(textRef.current.children[0], { x: 0, duration: 0.4, ease: "power1.out" });
    gsap.to(textRef.current.children[1], { x: 0, duration: 0.4, ease: "power1.out" });

    // Hide and reset the Limitless icon
    gsap.to(iconRef.current, {
      scale: 0,
      opacity: 0,
      rotation: 0, // Reset rotation
      duration: 0.5,
      ease: "power1.in",
    });
  };

  return (
  
  <a href="#home">
    <div
      className="split-text-container"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="split-text" ref={textRef}>
        <span>LIMIT</span>
        <span>LESS</span>
      </div>
      <div className="limitless-icon" ref={iconRef}>
        <img src="./images/icons8-infinity-100.png" alt="Limitless Icon" />
      </div>
      

    </div>
  </a>
  );
};

export default SplitTextWithLimitlessIcon;
